<template>
  <div class="aoform__btncontainer">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="sass">
.aoform__btncontainer
  display: flex
  justify-content: space-between
  @include from(breakpoints.$formMob)
    display: block
    >*:first-child
      margin-bottom: 8px
</style>